//@flow
import React from 'react';
import {makeStyles} from '@material-ui/core';

import defaultImage from '../../../../../../../assets/img/image-default.jpg';
import {colors} from '../../../../../../../assets/styles/colors';

const useStyles = makeStyles(theme => ({
  container: {
    display: 'grid',
    gridTemplateColumns: '1fr 1.2fr 1fr',
    gap: '.5rem',
    padding: '.75rem',
    borderRadius: '.5rem',
    background: 'white',
    height: '100%',
    width: '100%',
    maxHeight: '70px',
  },
  image: {
    padding: '.5rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    position: 'relative',

    '& img': {
      width: '24px',
      height: '24px',
      objectFit: 'contain',
    },
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: '.35rem',
    justifyContent: 'center',
    alignItems: 'center',
  },

  title: {
    width: '70%',
    height: 5,
    borderRadius: '.5rem',
    background: colors.grey400,
  },
  body: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    gap: '.25rem',
  },
  line: {
    width: '100%',
    height: 3,
    borderRadius: '.5rem',
    background: colors.grey300,
  },
  button: {
    width: '30%',
    height: 6,
    borderRadius: '.5rem',
    background: colors.grey400,
  },
}));

export default function Layout4() {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <div className={classes.content}>
        <div className={classes.title}></div>
        <div className={classes.body}>
          <div className={classes.line}></div>
          <div className={classes.line}></div>
          <div className={classes.line}></div>
        </div>
        <div className={classes.button}></div>
      </div>
      <div className={classes.image}>
        <img src={defaultImage} alt="mountain icon black and white" />
      </div>
      <div className={classes.content}>
        <div className={classes.title}></div>
        <div className={classes.body}>
          <div className={classes.line}></div>
          <div className={classes.line}></div>
          <div className={classes.line}></div>
        </div>
        <div className={classes.button}></div>
      </div>
    </div>
  );
}
